var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.value)?[_vm._v(_vm._s(_vm._f("moment")(_vm.value,"timezone", _vm.tz, _vm.format)))]:[_vm._v("--")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }